module.exports = __webpack_public_path__ + "img/singapore.cdf187c2.svg";